import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Tab,
    Tabs,
    CircularProgress
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import useAxios from '../../../../hooks/useAxios';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ExpandableValueTable from "./ExpandableValueTable";
import { addPurchasedStock } from '../../../../Actions/PurchasedStocks';
import PurchasedStocks from "../PurchasedStocks";
import SingleStockInvestment from "./SingleStockInvestment";
import BulkStockInvestment from "./BulkStockInvestment";

function TabPanel({ value, index, children }) {
    return value === index && <Box sx={{ p: 3 }}>{children}</Box>;
}

const VALUE = 'value';

const ValueTrading = ({ stocks }) => {

    let valueStocks = stocks[0].data;

    
    const placeBulkOrderURL = `${process.env.REACT_APP_APP_TRADE_URL}/trade/execute-bulk`;
    const getInvestmentReviewURL = `${process.env.REACT_APP_APP_TRADE_URL}/data/investment-preview`;
    const getSinglePriceURL = `${process.env.REACT_APP_APP_TRADE_URL}/data/price`;
    const token = useSelector((state) => state.user_authentication.token);

    const [tab, setTab] = React.useState(0);
    const [bulkAmount, setBulkAmount] = useState(null);
    const [previewData, setPreviewData] = useState([]);
    const [selectedStock, setSelectedStock] = useState([]);
    const [selectedStockCurrentPrice, setSelectedStockCurrentPrice] = useState(0);
    const [investmentAmount, setInvestmentAmount] = useState(null);
    const [orderMessage, setOrderMessage] = useState('');
    const [severity, setSeverity] = useState('');
    const [loading, setLoading] = useState(false);
    const [quantity, setQuanity] = useState(0);
    const [totalValue, settotalValue] = useState(0);
    const [failedOrders, setFailedOrders] = useState('');
    const [currentPurchased, setCurrentPurchased] = useState([]);

    const dispatch = useDispatch();

    const handleTabChange = (event, newValue) => {
        setTab(newValue);
        setOrderMessage('');
        setPreviewData([]);
    };


    const {
        data: placeSingleOrder,
        error: errorSingleOrder,
        loading: loadingSingleOrder,
        callAPI: callSingleOrderAPI
    } = useAxios();




    useEffect(() => {
        if (placeSingleOrder && !loadingSingleOrder) {
            setLoading(false);
            const result = placeSingleOrder.results?.[0];
            const failedStockOrders = placeSingleOrder.results?.filter((item) => !item.success);
            if (placeSingleOrder.success && result?.success) {
                setOrderMessage(result.message || "Stock purchased successfully.");
                setCurrentPurchased([result]);
                const total = (result.quantity * result.price).toFixed(2);
                dispatch(addPurchasedStock(
                    VALUE,
                    {
                        symbol: result.symbol,
                        quantity: result.quantity,
                        total,
                        price: result.price,
                        orderType: result.order_type,
                        tradeId: result.trade_id
                    }
                ));
                setSeverity("success");
            } else {
                setFailedOrders(failedStockOrders);
                setSeverity("warning");
                setOrderMessage("Your order failed. Please try again.");
            }
        } else if (loadingSingleOrder && errorSingleOrder) {
            console.error(errorSingleOrder);
            setLoading(false);
            setSeverity("error");
            setOrderMessage("Your order has failed. Please try again.");
        }
    }, [placeSingleOrder, errorSingleOrder, loadingSingleOrder]);



    const {
        data: placeBulkOrder,
        error: errorBulkOrder,
        loading: loadingBulkOrder,
        callAPI: callBulkOrderAPI
    } = useAxios();

    useEffect(() => {
        if (placeBulkOrder) {

            setLoading(false);

            if (placeBulkOrder.success === true) {
                const successfulOrders = placeBulkOrder.results.filter((item) => item.success);
                const failedStockOrders = placeBulkOrder.results.filter((item) => !item.success);

                if (successfulOrders.length > 0) {
                    setCurrentPurchased(successfulOrders);
                    successfulOrders.forEach(order => {
                        const total = (order.quantity * order.price).toFixed(2);
                        dispatch(addPurchasedStock(
                            VALUE,
                            {
                                symbol: order.symbol,
                                quantity: order.quantity,
                                total,
                                price: order.price,
                                orderType: order.order_type,
                                tradeId: order.trade_id
                            }
                        ));
                    });

                    setPreviewData([]);

                    if (failedStockOrders.length > 0) {
                        setFailedOrders(failedStockOrders);
                        setSeverity("warning");
                        setOrderMessage(`${successfulOrders.map(item => item.symbol).join(', ')} stock(s) purchased successfully. Failed to purchase stock(s): ${failedStockOrders.map(item => item.symbol).join(', ')}`);
                    } else {
                        setSeverity("success");
                        setOrderMessage(`${successfulOrders.map(item => item.symbol).join(', ')} stock(s) purchased successfully.`);
                    }

                } else if (failedStockOrders.length > 0) {
                    setFailedOrders(failedStockOrders);
                    setSeverity("error"); // Changed from "warning" to "error" for all failures
                    setOrderMessage(`All orders failed. Please review errors. Failed stock(s): ${failedStockOrders.map(item => item.symbol).join(', ')}`);
                } else {

                    setSeverity("warning");
                    setOrderMessage("No orders processed. Please try again.");
                }
            } else {

                setSeverity("error"); // Changed from "warning" to "error" for global failure
                setOrderMessage("Purchase failed. Please try again.");
            }
        } else if (loadingBulkOrder && errorBulkOrder) {
            console.error(errorBulkOrder);
            setLoading(false);
            setSeverity("error");
            setOrderMessage("Failed to Purchase. Please try again due to a network or server error.");
        }
    }, [placeBulkOrder, errorBulkOrder, loadingBulkOrder]);


    const {
        data: getInvestReview,
        error: errorInvestReview,
        loading: loadingInvestReview,
        callAPI: callInvestReviewAPI
    } = useAxios();

    useEffect(() => {
        if (getInvestReview) {
            console.log('placeSingleOrder ', getInvestReview);
            setLoading(false);
            if (getInvestReview.success === true) {
                console.log(getInvestReview.preview);
                setPreviewData(getInvestReview.preview);
            } else {
                setSeverity("warning");
                setOrderMessage("Get price failed. Please try again.");
            }
        } else if (loadingInvestReview && errorInvestReview) {
            setLoading(false);
            console.error(errorInvestReview);
            setSeverity("error");
            setOrderMessage("Failed to get Price. Please try again.");
        }
    }, ([getInvestReview, errorInvestReview, loadingInvestReview]));


    const {
        data: getStockPrice,
        error: errorStockPrice,
        loading: loadingStockPrice,
        callAPI: callStockPrice
    } = useAxios();

    useEffect(() => {
        if (getStockPrice && loadingStockPrice) {

            setLoading(false);

            if (getStockPrice.success) {
                setSelectedStockCurrentPrice(getStockPrice.price);
            } else {
                setSeverity("warning");
                setOrderMessage("Get price failed. Please try again.");
            }

        } else if (loadingStockPrice && errorStockPrice) {
            console.error(errorStockPrice);
            setLoading(false);
            setSeverity("error");
            setOrderMessage("Failed to get Price. Please try again.");
        }
    }, ([getStockPrice, errorStockPrice, loadingStockPrice]));

    const totalInvestment = previewData.reduce((sum, s) => sum + s.investment, 0);
    const remaining = bulkAmount - totalInvestment;




    const generatePreview = () => {
        const payload = {
            total_investment: bulkAmount,
            stocks: valueStocks.map(stock => stock.Ticker),
            strategy: "VALUE"
        };
        setLoading(true);
        callInvestReviewAPI(
            getInvestmentReviewURL,
            "POST",
            payload,
            {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            }
        )
    };




    const handleInvestmentAmount = (e) => {
        setInvestmentAmount(e.target.value);
        console.log(selectedStockCurrentPrice);
        const qn = Math.floor(e.target.value / selectedStockCurrentPrice);
        const tValue = (qn * selectedStockCurrentPrice).toFixed(2);
        console.log(qn);
        console.log(tValue);
        setQuanity(qn)
        settotalValue(tValue);
    }

    const handlePurchaseSingle = () => {
        const payload = {
            total_investment: investmentAmount,
            stocks: [selectedStock.Ticker.replace(/\.[a-zA-Z]+$/, "")],
            strategy: "VALUE",
            order_type: "BUY"
        };
        setLoading(true);
        callBulkOrderAPI(
            placeBulkOrderURL,
            "POST",
            payload,
            {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            }
        )
    };


    const handlePurchaseAll = () => {
        const payload = {
            total_investment: bulkAmount,
            stocks: valueStocks.map(stock => stock.Ticker.replace(/\.[a-zA-Z]+$/, "")),
            strategy: "VALUE",
            order_type: "BUY"
        };
        setLoading(true);
        callBulkOrderAPI(
            placeBulkOrderURL,
            "POST",
            payload,
            {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            }
        )
    };



    const handleSelectSell = (e) => {
        setSelectedStock(valueStocks.find((s) => s.Ticker === e.target.value))
        setLoading(true);
        setSelectedStockCurrentPrice(0);
        setOrderMessage('');
        callStockPrice(
            getSinglePriceURL + `/${e.target.value}`,
            "GET",
            null,
            {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            }
        )
    }



    const AvailableStocks = () => {
        console.log("current purchase", currentPurchased.length > 0);
        return (<>
            <Box sx={{ overflowX: "auto" }}>
                <ExpandableValueTable valueStocks={valueStocks} />
            </Box>

            <Box sx={{ mt: 4 }}>
                <Tabs
                    value={tab}
                    onChange={handleTabChange}
                    textColor="primary"
                    indicatorColor="primary"
                    sx={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: 2,
                        boxShadow: 1,
                    }}
                >
                    <Tab label="Single Stock Investment" />
                    <Tab label="Bulk Stock Investment" />
                </Tabs>

                <Box sx={{ mt: 3 }}>
                    <TabPanel value={tab} index={0}>
                        <SingleStockInvestment
                            valueStocks={valueStocks}
                            selectedStock={selectedStock}
                            selectedStockCurrentPrice={selectedStockCurrentPrice}
                            investmentAmount={investmentAmount}
                            quantity={quantity}
                            totalValue={totalValue}
                            orderMessage={orderMessage}
                            severity={severity}
                            handleSelectSell={handleSelectSell}
                            handleInvestmentAmount={handleInvestmentAmount}
                            handlePurchaseSingle={handlePurchaseSingle}
                        />
                    </TabPanel>
                    <TabPanel value={tab} index={1}>
                        <BulkStockInvestment
                            bulkAmount={bulkAmount}
                            setBulkAmount={setBulkAmount}
                            valueStocks={valueStocks}
                            previewData={previewData}
                            generatePreview={generatePreview}
                            orderMessage={orderMessage}
                            severity={severity}
                            totalInvestment={totalInvestment}
                            remaining={remaining}
                            handlePurchaseAll={handlePurchaseAll}
                        />
                    </TabPanel>
                </Box>
            </Box>
            {failedOrders.length > 0 && <Box
                sx={{
                    mt: 6,
                    p: 3,
                    backgroundColor: "#fafafa",
                    borderRadius: 2,
                    boxShadow: 2,
                    borderLeft: "5px solid #2d4890",
                }}
            >
                <Typography variant="h5" gutterBottom>
                    Unsuccessful Stock Orders
                </Typography>


                <Box component="ul" sx={{ pl: 3, listStyleType: "disc" }}>
                    {failedOrders.map((stock) => (
                        <Box component="li" key={stock.symbol} sx={{ mb: 1 }}>
                            <Typography variant="body1">
                                <strong>{stock.symbol}</strong> – Message: {stock.error}
                            </Typography>
                        </Box>
                    ))}
                </Box>

            </Box>}

            <Box
                sx={{
                    mt: 6,
                    p: 3,
                    backgroundColor: "#fafafa",
                    borderRadius: 2,
                    boxShadow: 2,
                    borderLeft: "5px solid #2d4890",
                }}
            >
                <Typography variant="h5" gutterBottom>
                    Current Purchased Stocks Summary
                </Typography>

                {currentPurchased.length > 0 ? (
                    <Box component="ul" sx={{ pl: 3, listStyleType: "disc" }}>
                        <PurchasedStocks purchased={currentPurchased} />
                    </Box>
                ) : (
                    <Typography color="text.secondary">No purchased stocks.</Typography>
                )}
            </Box>

        </>);
    }


    return (
        <Box p={3} sx={{ backgroundColor: "white", minHeight: "100vh", position: "relative" }}>
            <Box display="flex" alignItems="center" mb={2}>
                <ShowChartIcon sx={{ color: "#2d4890", mr: 1 }} />
                <Typography variant="h5" sx={{ color: "#2d4890", fontWeight: "bold" }}>
                    Value Strategy Selector
                </Typography>
            </Box>
            {loading && (
                <Box
                    position="absolute"
                    top={350}
                    left={0}
                    width="100%"
                    height="100%"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    zIndex={1000}
                    bgcolor="rgba(255, 255, 255, 0.6)" // optional dim background
                >
                    <CircularProgress size={40} />
                </Box>
            )}
            <Box sx={{ width: '100%', overflowX: 'hidden' }}>
                <Box sx={{ maxWidth: 2000, mx: "auto", width: "100%" }}> {AvailableStocks()}</Box>
            </Box>
        </Box>

    );
};

export default ValueTrading;
